import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
    Drawer,
    Button,
    Form,
    Input,
    Select,
    DatePicker,
    message,
    Icon,
} from "antd";
import styled from "styled-components";
import moment from "moment";

import InputCurrency from "~/components/UI/InputCurrency";
import * as contasPagarActions from "../actions";

var Option = Select.Option;
var TextArea = Input.TextArea;

var DrawerFooter = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px 24px;
    background: #fff;
    border-top: 1px solid #e8e8e8;
    display: flex;
    gap: 12px;
`;

var DrawerCreate = function(props) {
    var visible = props.visible;
    var onClose = props.onClose;
    var onSuccess = props.onSuccess;
    var record = props.record;
    var categories = props.categories;

    var dispatch = useDispatch();
    var [isSubmitting, setIsSubmitting] = useState(false);
    var [formData, setFormData] = useState({
        description: '',
        amount: 0,
        due_at: moment(),
        status: 'pending',
        paid_at: null,
        category_id: null,
        notes: '',
    });

    useEffect(function() {
        if (visible) {
            if (record) {
                setFormData({
                    description: record.description || '',
                    amount: record.amount || 0,
                    due_at: record.due_at ? moment(record.due_at) : moment(),
                    status: record.status || 'pending',
                    paid_at: record.paid_at ? moment(record.paid_at) : null,
                    category_id: record.category_id || null,
                    notes: record.notes || '',
                });
            } else {
                setFormData({
                    description: '',
                    amount: 0,
                    due_at: moment(),
                    status: 'pending',
                    paid_at: null,
                    category_id: null,
                    notes: '',
                });
            }
        }
    }, [visible, record]);

    var handleSubmit = function() {
        if (!formData.description) {
            message.error('Informe a descrição');
            return;
        }
        if (!formData.amount || formData.amount <= 0) {
            message.error('Informe um valor válido');
            return;
        }
        if (!formData.due_at) {
            message.error('Informe a data de vencimento');
            return;
        }

        setIsSubmitting(true);

        var data = {
            description: formData.description,
            amount: formData.amount,
            due_at: formData.due_at.format('YYYY-MM-DD'),
            status: formData.status,
            paid_at: formData.status === 'paid' && formData.paid_at ? formData.paid_at.format('YYYY-MM-DD') : null,
            category_id: formData.category_id,
            notes: formData.notes,
        };

        var action;
        if (record) {
            action = dispatch(contasPagarActions.updateContaPagar(record.id, data));
        } else {
            action = dispatch(contasPagarActions.createContaPagar(data));
        }

        action
            .then(function() {
                message.success(record ? 'Conta atualizada com sucesso!' : 'Conta criada com sucesso!');
                setIsSubmitting(false);
                onSuccess();
            })
            .catch(function(err) {
                var errorMsg = err && err.response && err.response.data && err.response.data.message;
                message.error(errorMsg || 'Erro ao salvar conta');
                setIsSubmitting(false);
            });
    };

    var handleChange = function(field, value) {
        setFormData(function(prev) {
            var newData = {};
            for (var key in prev) {
                newData[key] = prev[key];
            }
            newData[field] = value;
            return newData;
        });
    };

    return (
        <Drawer
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <Icon type="wallet" style={{ color: '#1890ff', fontSize: 18 }} />
                    <span style={{ fontWeight: 600 }}>{record ? 'Editar' : 'Nova'} Conta a Pagar</span>
                </div>
            }
            placement="right"
            visible={visible}
            onClose={onClose}
            width={500}
            bodyStyle={{ paddingBottom: 80 }}
        >
            <Form layout="vertical">
                <Form.Item label="Descrição" required>
                    <Input
                        placeholder="Descrição da conta"
                        value={formData.description}
                        onChange={function(e) { handleChange('description', e.target.value); }}
                    />
                </Form.Item>

                <Form.Item label="Valor" required>
                    <InputCurrency
                        value={formData.amount}
                        onChangeEvent={function(e, maskedValue, floatValue) {
                            handleChange('amount', floatValue);
                        }}
                        style={{ width: '100%' }}
                    />
                </Form.Item>

                <Form.Item label="Vencimento" required>
                    <DatePicker
                        format="DD/MM/YYYY"
                        value={formData.due_at}
                        onChange={function(date) { handleChange('due_at', date); }}
                        style={{ width: '100%' }}
                        placeholder="Selecione a data"
                    />
                </Form.Item>

                <Form.Item label="Status">
                    <Select
                        value={formData.status}
                        onChange={function(value) {
                            handleChange('status', value);
                            if (value === 'paid' && !formData.paid_at) {
                                handleChange('paid_at', moment());
                            }
                        }}
                    >
                        <Option value="pending">Pendente</Option>
                        <Option value="paid">Pago</Option>
                    </Select>
                </Form.Item>

                {formData.status === 'paid' && (
                    <Form.Item label="Data do Pagamento">
                        <DatePicker
                            format="DD/MM/YYYY"
                            value={formData.paid_at}
                            onChange={function(date) { handleChange('paid_at', date); }}
                            style={{ width: '100%' }}
                            placeholder="Selecione a data"
                        />
                    </Form.Item>
                )}

                <Form.Item label="Categoria">
                    <Select
                        placeholder="Selecione uma categoria"
                        value={formData.category_id}
                        onChange={function(value) { handleChange('category_id', value); }}
                        allowClear
                        showSearch
                        filterOption={function(input, option) {
                            return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                        }}
                    >
                        {categories.map(function(cat) {
                            return (
                                <Option key={cat.id} value={cat.id}>
                                    {cat.value}
                                </Option>
                            );
                        })}
                    </Select>
                </Form.Item>

                <Form.Item label="Observações">
                    <TextArea
                        rows={3}
                        placeholder="Observações adicionais (opcional)"
                        value={formData.notes}
                        onChange={function(e) { handleChange('notes', e.target.value); }}
                    />
                </Form.Item>
            </Form>

            <DrawerFooter>
                <Button onClick={onClose} size="large" style={{ flex: 1 }}>
                    Cancelar
                </Button>
                <Button
                    type="primary"
                    onClick={handleSubmit}
                    loading={isSubmitting}
                    size="large"
                    style={{ flex: 2 }}
                >
                    <Icon type="check" /> {record ? 'Salvar' : 'Criar'}
                </Button>
            </DrawerFooter>
        </Drawer>
    );
};

export default DrawerCreate;
